export const TYPE_MAX_MINS = {
  double: 1.79769313486232e308,
  integer: 2147483647,
};
